/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { LI, SVG, UL } from "../../../AbstractElements";
import { Href } from "../../../Constant";
import { useAppSelector } from "../../../Redux-Toolkit/Hooks";
import { ShouldActiveProp, ShouldActiveProps, sidebarTypes } from "../../../Type/SideBarType";

export const SubMenu = ({ menu, isOpen, setIsOpen, level, className }: sidebarTypes) => {
  const { sidebarIconType } = useAppSelector((state) => state.themeCustomizer);
  const { pathname } = useLocation();
  const [icon, setIcon] = useState(true);
  const [pinedMenu, setPinedMenu] = useState<string[]>([]);
  const { t } = useTranslation();
  const [close, setClose] = useState(false);

  useEffect(() => {
    const shouldSetActive = ({ item }: ShouldActiveProp) => {
      var returnValue = false;
      if (item?.url === pathname) {
        returnValue = true;
      }
      if (!returnValue && item?.menu) {
        item?.menu.every((subItem) => {
          returnValue = shouldSetActive({ item: subItem });
          return !returnValue;
        });
      }
      return returnValue;
    };

    menu.forEach((item: ShouldActiveProps) => {
      let gotValue: boolean = shouldSetActive({ item });
      if (gotValue) {
        let temp = isOpen;
        temp[level] = item.title;
        setIsOpen([...temp]);
      }
    });
  }, [level,pathname,setIsOpen,menu]);

  const handlePined = (value: string) => {
    if (pinedMenu.includes(value)) {
      let filterMenu = pinedMenu.filter((item) => item !== value);
      setPinedMenu(filterMenu);
    } else {
      setPinedMenu([...pinedMenu, value]);
    }
  };

  return (
    <Fragment>
      {menu.map((item, index) => (
        <LI className={`${level === 0 ? "sidebar-list" : ""} ${pinedMenu.includes(item.title) ? "pined" : ""}`} key={index}>
          {level === 0 && <i className="fa fa-thumb-tack" onClick={() => handlePined(item.title)}></i>}
          <Link
            to={item.url ? item.url : Href}
            className={`${level === 0 ? "sidebar-link sidebar-title" : ""} ${isOpen[level] === item.title ? "active" : ""}`}
            onClick={() => {
              const temp = isOpen;
              temp[level] = item.title !== temp[level] && item.title;
              setIsOpen(temp);
              setIcon(!icon);
              setClose(true);
            }}>
            {item.icon1 && <SVG className={`${sidebarIconType}-icon`} iconId={`${sidebarIconType}-${item.icon1}`} />}
            <span>
              {t(item.title)} {item.menu && icon ? <i className="fa fa-angle-right"></i> : item.menu && <i className="fa fa-angle-down"></i>}
            </span>
          </Link>
          {item.menu && (
            <UL className={`${className ? className : "sidebar-submenu"} ${isOpen[level] === item.title && close ? "d-block" : "d-none"}`}>
              <SubMenu menu={item.menu} isOpen={isOpen} setIsOpen={setIsOpen} level={level + 1} className="nav-sub-childmenu submenu-content" />
            </UL>
          )}
        </LI>
      ))}
    </Fragment>
  );
};
